<template>
  <div id="home-page">
    <div class="hero-text">
      <h1 class="font-weight-bold">Gadget Space <span><font-awesome-icon icon="rocket" /></span></h1>
      <h2>Your Gadget Solution</h2>
      <h5>Gadget Space is a leading Samsung Premium Reseller in Indonesia specializing in Samsung products and a wide range of complementary accessories, software and other products.</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>

<style>

</style>
